import React from "react"
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';

import TextField from '@material-ui/core/TextField';


export default class ExpirySelector extends React.Component {
    state = {
        selectedExpiry: "",
        expiryList: []
    }

    requestExpiryData() {
        const ticker = (this.props.ticker === "") ? "global" : this.props.ticker
        if (ticker==="global") {return;}
        const url = `https://api.harsip.com/options/${ticker}/`

        return (fetch(url)
                .then(res => res.json())
                .then((data) => {
                            this.setState({ expiryList: data },this.selectExpiry(data[0])) 
                            })
                .catch(console.log))
    }
    refreshExpiryData() {
        this.setState({expiryList: []},this.requestExpiryData);
    }
    selectExpiry(expiry) {
        this.setState({selectedExpiry:expiry},this.notifyOfSelectionChange(expiry))
    }
    selectionChanged = event =>  {
        this.selectExpiry(event.target.value)
    }
    notifyOfSelectionChange(expiry) {
        this.props.onSelectedExpiryChange(expiry) //pass it up to container
    }
    componentDidMount() {
        this.refreshExpiryData()
    }
    componentDidUpdate(prevProps) {
        if (prevProps.ticker!==this.props.ticker) {   
            this.refreshExpiryData()
        }
    }

    render() {
        if (this.state.expiryList.length === 0) {
            if (this.props.ticker === "") return <></>
            return <div><CircularProgress variant="indeterminate" thickness={1.0} color="primary" /></div>
        }
        const menuItemList = []//[<MenuItem key="" value=""></MenuItem>]
        this.state.expiryList.forEach(exp => {
            menuItemList.push(
                    <MenuItem key={exp} value={exp}>{exp}</MenuItem>
                )
        });

        return (
            <TextField select label="expiry" id="optionExpirySelect"
                value={this.state.selectedExpiry}
                onChange={this.selectionChanged}
                variant="outlined"
                helperText="Select option expiration">
                {menuItemList}
            </TextField>
        )

    }

}

